import React, { PureComponent } from 'react'
import DownIcon from 'mdi-react/ChevronDownIcon'
import TopbarMenuLink from './TopbarMenuLink'
import { DropdownItem, DropdownToggle, DropdownMenu, UncontrolledDropdown } from 'reactstrap'
import { signout } from '../../../redux/actions/userActions'
import { connect } from 'react-redux'

const Ava = process.env.PUBLIC_URL + '/img/profile-1.png'

class TopbarProfile extends PureComponent {
  render () {
    return (
      <UncontrolledDropdown id='account-dropdown' className='topbar__profile'>
        <DropdownToggle className='topbar__avatar'>
          <img className='topbar__avatar-img' src={Ava} alt='avatar' />
          <p className='topbar__avatar-name'>
            {this.props.user && `${this.props.user.given_name} ${this.props.user.family_name}`}
          </p>
          <DownIcon className='topbar__avatar-icon' />
        </DropdownToggle>
        <DropdownMenu className='topbar__menu dropdown__menu inherit_display'>
          {/* <DropdownItem id='profile-top-nav'>
            <TopbarMenuLink title='Settings' icon='user' path='/app/user/profile' />
          </DropdownItem> */}
          {/* <DropdownItem id='payment-info-top-nav'>
            <TopbarMenuLink title='Payment Information' icon='calendar-full' path='/app/payments/pricingcards' />
    </DropdownItem> */}
          {/* <DropdownItem divider className='topbar__menu-divider' /> */}
          <DropdownItem id='logout-top-nav'>
            <TopbarMenuLink title='Log Out' icon='exit' path='/logout' />
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    )
  }
}

function mapStateToProps (state) {
  return {
    user: state.auth.user
  }
}

export default connect(mapStateToProps, { signout })(TopbarProfile)



// WEBPACK FOOTER //
// ./src/pages/_layout/topbar/TopbarProfile.js